// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bPNGI_VbtbXQ8v {
  display: flex;
  position: relative;
  flex-grow: 0;
  flex-wrap: wrap;
  align-items: center;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 8px 0;
  row-gap: 0;
}
.bPNGI_VbtbXQ8v.wNTQO3fwQlladz {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: revert;
  padding: 8px 4px 16px;
  overflow: hidden;
  border-radius: inherit;
  cursor: pointer;
  writing-mode: vertical-lr;
}
.bPNGI_VbtbXQ8v.wNTQO3fwQlladz:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.bPNGI_VbtbXQ8v.wNTQO3fwQlladz:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.firefox .bPNGI_VbtbXQ8v.wNTQO3fwQlladz,
.safari .bPNGI_VbtbXQ8v.wNTQO3fwQlladz {
  width: 40px;
  padding-right: 0;
  padding-left: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listHeader": `bPNGI_VbtbXQ8v`,
	"collapsed": `wNTQO3fwQlladz`
};
export default ___CSS_LOADER_EXPORT___;
